import React from 'react';
import { useTheme } from '../context/ThemeContext';
import './ThemeToggle.css';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button 
      className={`theme-toggle ${theme}`} 
      onClick={toggleTheme}
      aria-label="Toggle Theme"
      title="Toggle Light/Dark Mode"
    >
      <div className="toggle-thumb" />
      <span className="icon sun">☀️</span>
      <span className="icon moon">🌙</span>
    </button>
  );
}
